import { InboundStatus, InboundStatuses } from "../../utils/constants";

// The yard calls a scheduled-but-not-yet-arrived delivery IN_TRANSIT, but the
// carrier reading the same row is the one still to make the trip, so the
// carrier portal says "Pending" instead. Only the wording differs — the status
// itself is untouched, and every other status keeps the yard's name for it.
const CARRIER_IN_TRANSIT_LABEL = "Pending";

export const CarrierInboundStatuses = InboundStatuses.map((status) =>
  status.id === InboundStatus.IN_TRANSIT
    ? { ...status, name: CARRIER_IN_TRANSIT_LABEL }
    : status,
);

// Load-search results print the raw status enum on a chip.
export const carrierStatusChipLabel = (status) =>
  status === InboundStatus.IN_TRANSIT
    ? CARRIER_IN_TRANSIT_LABEL.toUpperCase()
    : status;
